var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":function($event){return _vm.resetPWD()}}},[_vm._v("Forgot your password?")])
}
var staticRenderFns = []

export { render, staticRenderFns }